import React, { useEffect } from "react";
import L from "leaflet";
import { useMap } from "react-leaflet";

const ClassLegend = ({ selectedParameter, colorMapping }) => {
  const map = useMap();

  useEffect(() => {
    if (!map || !selectedParameter || !colorMapping[selectedParameter]) return;

    const legend = L.control({ position: "topright" });

    legend.onAdd = () => {
      const div = L.DomUtil.create("div", "info legend");

      // Tailwind CSS classes for styling
      div.className = `
        bg-white p-4 rounded-lg shadow-lg text-sm leading-6
        md:w-[350px] md:h-[300px] md:bg-opacity-80
        w-[250px] h-[200px] bg-opacity-90
      `;

      const labels = colorMapping[selectedParameter].map(({ color, label }) => `
        <div class="flex items-center mb-2">
          <div class="w-12 h-12 md:w-20 md:h-20 rounded-md mr-2" style="background: ${color};"></div>
          <span class="text-base md:text-2xl font-serif text-gray-700">${label}</span>
        </div>
      `);

      // Title and color labels
      div.innerHTML = `
        <h4 class="text-lg md:text-2xl font-serif font-bold mb-4">${selectedParameter}</h4>
        ${labels.join("")}
        <div class="mt-4 text-sm md:text-base font-semibold text-gray-800 flex items-center h-10 p-2 rounded-md bg-yellow-300">
          The wheat is at flowering stage <span class="ml-2"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="green" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-flower-2"><path d="M12 5a3 3 0 1 1 3 3m-3-3a3 3 0 1 0-3 3m3-3v1M9 8a3 3 0 1 0 3 3M9 8h1m5 0a3 3 0 1 1-3 3m3-3h-1m-2 3v-1"/><circle cx="12" cy="8" r="2"/><path d="M12 10v12"/><path d="M12 22c4.2 0 7-1.667 7-5-4.2 0-7 1.667-7 5Z"/><path d="M12 22c-4.2 0-7-1.667-7-5 4.2 0 7 1.667 7 5Z"/></svg></span>
        </div>
      `;

      return div;
    };

    legend.addTo(map);
    return () => {
      legend.remove();
    };
  }, [map, selectedParameter, colorMapping]);

  return null;
};

export default ClassLegend;